import React, { useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  StyledBox,
  StyledBoxDis,
  StyledBoxInner,
  StyledDivider,
  StyledOrBox,
  StyledTypographyDo,
  StyledTypographyFor,
  StyledTypographyOr,
  StyledTypographyWel,
  StyleSpan,
  StyleTypographyText,
} from "./style";
import goggle from "../../../assets/images/goggle.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import theme from "../../../theme";
import CustomInput from "../../common/input/CustomInput";
import SocialButton from "../../common/social-button/SocialButton";
import CustomButton from "../../common/button/CustomButton";
import { cookie } from "../../../cookies/cookies";

const validationSchema = Yup.object({
  emailOrPhone: Yup.string()
    .trim()
    .test("valid-email-or-phone", function (value) {
      if (!value) {
        return this.createError({
          message: "Enter a valid email or 10-digit phone number",
        });
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phoneRegex = /^\+([0-9]{1,4})\s([0-9]{7,15})$/;

      if (emailRegex.test(value)) return true;
      if (phoneRegex.test(value)) return true;
      return this.createError({
        message: "Enter a valid email or 10-digit phone number",
      });
    })
    .required("email or phone number is required "),
  password: Yup.string().trim().required("password is required"),
});

const trimLoginValues = (values) => ({
  emailOrPhone: values.emailOrPhone.trim(),
  password: values.password.trim(),
});

const LoginForm = ({ onSubmit, isSubmitting = false }) => {
  const navigate = useNavigate();
  const handleRegister = () => {
    navigate("/register");
  };
  const handleForgot = () => {
    navigate("/forgot");
  };

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const handleGoogleLogin = () => {
    const googleAuthUrl = `${process.env.REACT_APP_API_URL}/auth/google`;
    window.open(googleAuthUrl, "_self");
  };
  const token = params?.get("token");
  const profileDetails = useSelector((state) => state?.auth?.profileDetails);
  const isAdmin = profileDetails.user_type === "admin";
 
  useEffect(() => {
    if (token) {
      cookie.set("token", token);
      const redirectPath = isAdmin ? "/admin/dashboard" : "/dashboard";
      navigate(redirectPath);
    }
  }, [token, isAdmin, navigate]);

  return (
    <StyledBox>
      <StyledBoxInner>
        <StyledTypographyWel>WELCOME BACK</StyledTypographyWel>
        <StyleTypographyText>Log In to your Account</StyleTypographyText>
        <Formik
          initialValues={{ emailOrPhone: "", password: "" }}
          validationSchema={validationSchema}
          onSubmit={(values) => onSubmit(trimLoginValues(values))}
        >
          {({ errors, handleChange, handleBlur, values, touched }) => (
            <Form>
              <StyledBoxDis>
                <CustomInput
                  label="Email / Phone Number"
                  name="emailOrPhone"
                  value={values.emailOrPhone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.emailOrPhone && Boolean(errors.emailOrPhone)}
                  helperText={touched.emailOrPhone && errors.emailOrPhone}
                  autoComplete="current-emailOrPhone"
                />
                <CustomInput
                  label="Password"
                  name="password"
                  type="password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.password && errors.password}
                  helperText={touched.password && errors.password}
                  autoComplete="current-password"
                />
                <StyledTypographyFor onClick={() => handleForgot()}>
                  Forgot Password?
                </StyledTypographyFor>
                <CustomButton
                  fontSize={theme.typography.regular.fontSize}
                  type="submit"
                  btnLabel="GET STARTED"
                  btntype={"primary"}
                  height="56px"
                  disabled={isSubmitting}
                  isLoading={isSubmitting}
                />
                <StyledOrBox>
                  <StyledDivider />
                  <StyledTypographyOr>Or</StyledTypographyOr>
                  <StyledDivider />
                </StyledOrBox>
                <SocialButton
                  height="48px"
                  label="Sign in with Google"
                  icon={goggle}
                  onClick={handleGoogleLogin}
                />
                <StyledTypographyDo>
                  Don’t have an account?
                  <StyleSpan onClick={() => handleRegister()}>
                    Create a Account
                  </StyleSpan>
                </StyledTypographyDo>
              </StyledBoxDis>
            </Form>
          )}
        </Formik>
      </StyledBoxInner>
    </StyledBox>
  );
};

export default LoginForm;
